import React, { useContext, useEffect, useRef, useState } from "react";
import "../Styles/SynergyBillingReports.css";
import { Download, FunnelSimple, MagnifyingGlass } from "phosphor-react";
import NavSub from "../components/NavSub";
import { clientApiUrl, reportApiUrl } from "../utils/GetUrl";
import { AuthContext } from "../context/AuthContext";
import ToastComponent from "../components/ToastComponent";
import * as XLSX from "xlsx";
import { CircularProgress } from "@mui/material";

function BillingByDepartment() {
  const toastRef = useRef();
  const [years, setYears] = useState([]);
  const [department, setDepartment] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const { handleAuthExpiry, logout, token } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [isDepartmentOpen, setIsDepartmentOpen] = useState(false);
  const [deptSearch, setDeptSearch] = useState("");
  const [department2, setDepartment2] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [loadingBillingReports, setLoadingBillingReports] = useState(false);
  const dropdownsearchRef = useRef(null);
  const [end, setEnd] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Services");
  const [isOpen, setIsOpen] = useState(false);

  const options = [
    "Services",
    "Accounting & Services",
    "Statutory & Tax Reporting",
  ];
  const handleOptionClick = (option) => {
    setSelectedOption(option); // Set the selected option
    setIsOpen(false); // Close dropdown after selecting an option
  };
  const toggleDropdown = () => {
    setIsOpen(!isOpen); // Toggle dropdown visibility
  };

  const handleDepartmentMenuClick = () => {
    setIsDepartmentOpen(!isDepartmentOpen);
  };

  const handleClearAllDept = () => {
    setSelectedDepartments([]);
    setDeptSearch("");
    setDepartment2([]);
  };
  const handleCheckboxDepartmentChange = (dep) => {
    const exists = selectedDepartments.some((item) => item.name === dep.name);
    if (exists) {
      setSelectedDepartments(
        selectedDepartments.filter((item) => item.name !== dep.name)
      );
    } else {
      setSelectedDepartments([...selectedDepartments, dep]);
    }
  };
  const fetchDepartments = async () => {
    if (!token) return;
    setLoadingDepartments(true);
    try {
      const response = await fetch(
        `${clientApiUrl}/GetAllDepartment?Page=1&ItemsPerPage=500`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }

      const handleAuthError = handleAuthExpiry(response);
      if (handleAuthError === true) {
        toastRef.current.showToast("Your Session has expired", "error");
        logout();
        return false;
      }

      if (response.ok) {
        const data = await response.json();

        // Remove duplicates based on department name
        const uniqueDepartments = Array.from(
          new Map(data.map((dep) => [dep.name.toLowerCase(), dep])).values()
        );

        setDepartment(uniqueDepartments);
        setDepartment2(uniqueDepartments);
      } else {
        console.error("Network response was not ok");
      }
      setLoadingDepartments(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (token) {
      fetchDepartments();
    }
  }, [token]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const yearRange = Array.from(
      { length: 21 },
      (_, i) => currentYear - 10 + i
    );
    setYears(yearRange);
  }, []);

  //integration

  const [billingReports, setbillingReports] = useState([]);
  const fetchBillingReports = async (startDate, endDate) => {
    if (!token) return;
    setLoadingBillingReports(true);
    try {
      const response = await fetch(
        `${reportApiUrl}/GetBillingReport?StartDate=${startDate}&EndDate=${endDate}&IsCustomers=1`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }

      const handleAuthError = handleAuthExpiry(response);
      if (handleAuthError === true) {
        toastRef.current.showToast("Your Session has expired", "error");
        logout();
        return false;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      setbillingReports(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingBillingReports(false);
    }
  };

  const [selectedMonth, setSelectedMonth] = useState(
    new Date().toISOString().slice(0, 7)
  );

  const handleMonthChange = (newMonth) => {
    const month = newMonth?.target ? newMonth.target.value : newMonth;

    setSelectedMonth(month);
    const startDate = `${month}-01`;

    // Extract year and month
    const [year, monthNum] = month.split("-");
    const endDate = new Date(Date.UTC(year, monthNum, 0)) // Month is 1-based here
      .toISOString()
      .slice(0, 10);

    // Call the API with new dates
    fetchBillingReports(startDate, endDate);
  };

  useEffect(() => {
    const today = new Date();
    const defaultMonth = `${today.getFullYear()}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}`;

    // Create a mock event object to call handleMonthChange
    const mockEvent = { target: { value: defaultMonth } };

    // Call handleMonthChange with the mock event
    handleMonthChange(mockEvent);
  }, [token]);

  const handleDownload = () => {
    const aggregatedData = billingReports.reduce((acc, row) => {
      const key = `${row.Department}-${row.Services}`;

      const existing = acc.find((item) => item.key === key);

      if (existing) {
        existing.BillingHours += parseFloat(row.BillingHours) || 0;
        existing.TotalRev += parseFloat(row.TotalRev) || 0;
        existing.CustomerNames.add(row.CustomerName.toLowerCase().trim());
      } else {
        acc.push({
          key,
          Services: row.Services,
          Department: row.Department,
          "Department Head": row.DepartmentHead,
          BillingHours: parseFloat(row.BillingHours) || 0,
          TotalRev: parseFloat(row.TotalRev) || 0,
          CustomerNames: new Set([row.CustomerName.toLowerCase().trim()]),
        });
      }

      return acc;
    }, []);

    const tableData = aggregatedData
      .filter((row) => {
        if (selectedDepartments.length === 0) {
          return true;
        }
        return selectedDepartments.some((item) => item.name === row.Department);
      })
      .map((row) => ({
        Services: row.Services,
        Department: row.Department,
        "Department Head": row["Department Head"],
        "Billing Hours": row.BillingHours.toFixed(2),
        "Total Revenue": row.TotalRev.toFixed(2),
        "No. of Customers": row.CustomerNames.size,
      }));

    const totalBillingHours = aggregatedData.reduce(
      (sum, row) => sum + row.BillingHours,
      0
    );
    const totalRevenue = aggregatedData.reduce(
      (sum, row) => sum + row.TotalRev,
      0
    );
    const totalCustomers = aggregatedData.reduce(
      (sum, row) => sum + row.CustomerNames.size,
      0
    );

    tableData.push({
      Services: "Total",
      Department: "",
      "Department Head": "",
      "Billing Hours": totalBillingHours.toFixed(2),
      "Total Revenue": totalRevenue.toFixed(2),
      "No. of Customers": totalCustomers,
    });

    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Billing Report");

    XLSX.writeFile(workbook, "BillingReport.xlsx");
  };

  return (
    <div>
      <ToastComponent ref={toastRef} timeout={10000} />
      <NavSub />
      <div className="SynergyBillingReports_header">
        <div className="Import_field_btn_billing" onClick={handleDownload}>
          <Download size={35} color="#3d025f" weight="fill" />
          <label className="Nav-Sub-btn"> DOWNLOAD</label>
        </div>
        <div className="cal-icon-change-reporting-activities">
          <input
            type="month"
            value={selectedMonth}
            onChange={handleMonthChange}
            className="calender_quality"
          />
        </div>
      </div>
      <div
        className="synergy-billing-reports"
        style={{
          width: "95%",
          overflow: "auto",
          zIndex: 1,
          position: "relative",
          overflowY: "auto",
          height: "80vh",
        }}
      >
        <table>
          <thead
            style={{
              position: "sticky" /* Makes the header sticky */,
              top: 0 /* Keeps it at the top of the table container */,
              zIndex: 1 /* Ensures the header stays on top of the body when scrolling */,
            }}
          >
            <tr>
              <th>
                <div>
                  <div className="header_title-new">
                    <div className="header_title">{selectedOption}</div>

                    <FunnelSimple
                      weight="bold"
                      size={20}
                      color="#061347"
                      style={{ cursor: "pointer" }}
                      onClick={toggleDropdown}
                    />
                  </div>

                  {isOpen && (
                    <div className="dropdown-list-billingreports">
                      {options.map((option, index) => (
                        <div
                          key={index}
                          className="dropdown-item-billing-reports"
                          onClick={() => handleOptionClick(option)}
                        >
                          {option}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </th>
              <th>
                <div className="header_title">
                  Department
                  <FunnelSimple
                    onClick={handleDepartmentMenuClick}
                    weight="bold"
                    size={20}
                    color="#061347"
                  />
                  {isDepartmentOpen && (
                    <div ref={dropdownsearchRef}>
                      <div className="search-drop-page">
                        <div className="main-suggestion_reporting">
                          <div className="input-suggestion">
                            <div className="icon-search-phospher">
                              <MagnifyingGlass
                                size={20}
                                color="#ada4a4"
                                weight="fill"
                              />
                            </div>
                            <input
                              type="text"
                              value={deptSearch}
                              className="input-suggestion-search"
                              onChange={(e) => {
                                const value = e.target.value.toLowerCase();
                                setDeptSearch(value);
                                setDepartment2(
                                  department.filter((dep) =>
                                    dep.name.toLowerCase().includes(value)
                                  )
                                );
                              }}
                              placeholder="Start typing..."
                            />
                            <button
                              className="clear-title"
                              onClick={handleClearAllDept}
                            >
                              Clear All
                            </button>
                          </div>
                          <div style={{ overflowY: "auto" }}>
                            {department2.map((dep) => (
                              <div key={dep.id} className="suggestion-list-li">
                                <input
                                  type="checkbox"
                                  className="check-searchbox"
                                  checked={selectedDepartments.some(
                                    (item) => item.name === dep.name
                                  )}
                                  onChange={() =>
                                    handleCheckboxDepartmentChange(dep)
                                  }
                                />
                                <label className="li-content">{dep.name}</label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </th>
              <th>Department Head</th>
              <th style={{ textAlign: "right" }}>Billing Hours</th>
              <th style={{ textAlign: "right" }}>Total Revenue</th>
              <th style={{ textAlign: "right" }}>No. of Customers</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(
              billingReports
                .filter((row) => {
                  if (selectedOption && selectedOption !== "Services") {
                    return row.Services === selectedOption;
                  }
                  return true;
                })
                .filter((row) => {
                  if (selectedDepartments.length === 0) {
                    return true;
                  }
                  return selectedDepartments.some(
                    (item) => item.name === row.Department
                  );
                })
                .reduce((acc, row) => {
                  const serviceKey = `${row.Department} - ${row.Services}`;
                  if (!acc[serviceKey]) {
                    acc[serviceKey] = {
                      ...row,
                      RegisteredTime: 0,
                      TotalRev: 0,
                      CustomerNames: new Set(),
                    };
                  }
                  acc[serviceKey].RegisteredTime += parseFloat(row.RegisteredTime) || 0;
                  acc[serviceKey].TotalRev += parseFloat(row.TotalRev) || 0;
                  acc[serviceKey].CustomerNames.add(
                    row.CustomerName.toLowerCase().trim()
                  );
                  return acc;
                }, {})
            ).map(([serviceKey, data], index) => (
              <tr
                key={index}
                className={index % 2 === 0 ? "row-white" : "row-gray"}
              >
                <td>{data.Services}</td>
                <td>{data.Department}</td>
                <td>{data.DepartmentHead}</td>
                <td
                  className="text-right"
                  style={{ textAlign: "right", paddingRight: "50px" }}
                >
                  {parseFloat(data.RegisteredTime).toFixed(2)}
                </td>
                <td
                  className="text-right"
                  style={{ textAlign: "right", paddingRight: "50px" }}
                >
                  {parseFloat(data.TotalRev).toFixed(2)}
                </td>
                <td style={{ textAlign: "right", paddingRight: "50px" }}>
                  {data.CustomerNames.size}
                </td>
              </tr>
            ))}
          </tbody>

          <tfoot>
            <tr
              className="total-billing-row"
              style={{
                position: "sticky",
                bottom: 0,
                backgroundColor: "#50145A",
                color: "#FFFFFF",
                fontWeight: "bold",
              }}
            >
              <td colSpan={3}>Total Billing</td>
              <td
                className="text-right"
                style={{ textAlign: "right", paddingRight: "50px" }}
              >
                {billingReports
                  .filter((row) => {
                    if (selectedDepartments.length === 0) {
                      return true;
                    }
                    return selectedDepartments.some(
                      (item) => item.name === row.Department
                    );
                  })
                  .reduce((sum, row) => sum + row.RegisteredTime, 0)
                  .toFixed(2)}
              </td>
              <td
                className="text-right"
                style={{ textAlign: "right", paddingRight: "50px" }}
              >
                {billingReports
                  .filter((row) => {
                    if (selectedDepartments.length === 0) {
                      return true;
                    }
                    return selectedDepartments.some(
                      (item) => item.name === row.Department
                    );
                  })
                  .reduce((sum, row) => sum + row.TotalRev, 0)
                  .toFixed(2)}
              </td>
              <td
                className="text-right"
                style={{ textAlign: "right", paddingRight: "50px" }}
              >
                {
                  new Set(
                    billingReports
                      .filter((row) => {
                        if (selectedDepartments.length === 0) {
                          return true;
                        }
                        return selectedDepartments.some(
                          (item) => item.name === row.Department
                        );
                      })
                      .map((row) => row.CustomerName.toLowerCase().trim())
                  ).size
                }
              </td>
            </tr>
          </tfoot>
        </table>
        {(loadingDepartments || loadingBillingReports) && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px",
            }}
          >
            <CircularProgress style={{ color: "purple" }} width={40} />
          </div>
        )}
      </div>
    </div>
  );
}

export default BillingByDepartment;
